<template>
  <el-card class="chefDevice">
    <div class="register">
      <!-- <el-button
        type="primary"
        class="left"
        v-if="btnPer('sta_outputDeviceList')"
        size="mini"
        @click="handleExport"
      >
        批量导出
      </el-button> -->
      <el-button
        type="primary"
        @click="$refs['uploadInput'].click()"
        size="mini"
      >
        导入
        <input
          style="display:none"
          @change="handleImportClick"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          ref="uploadInput"
          type="file"
        />
      </el-button>
      <search
        class="right"
        :searchList="searchList"
        :searchParams="searchParams"
        formName="searchParams"
        @resetForm="resetForm"
        @submitForm="submitForm"
      ></search>
      <table-page
        class="table"
        :page="tableFilter.page"
        :limit="tableFilter.pageSize"
        :tableDable="tableData"
        @handleSelectionChange="handleSelectionChange"
        :selection="false"
        :columns="columns"
      ></table-page>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="tableFilter.page"
        :limit.sync="tableFilter.pageSize"
        @pagination="getRegisterList"
      />
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="详情"
      :visible.sync="seeBox"
      width="550px"
      custom-class="seeBox"
    >
      <div class="see-center">
        <p>
          <font class="title">产品类型：</font>
          <font>{{ seeForm.productType && seeForm.productType.productType }}</font>
        </p>
        <p>
          <font class="title">产品型号：</font>
          <font>{{ seeForm.product && seeForm.product.productModel }}</font>
        </p>
        <p>
          <font class="title">MAC地址：</font>
          <font>{{ seeForm.mac }}</font>
        </p>
        <p>
          <font class="title">SN号：</font>
          <font>{{ seeForm.sn }}</font>
        </p>
        <p>
          <font class="title">IP地址：</font>
          <font>{{ seeForm.ip }}</font>
        </p>
        <p>
          <font class="title">MCU固件版本：</font>
          <font>{{ seeForm.mcuVersion }}</font>
        </p>
        <p>
          <font class="title">安卓屏app版本：</font>
          <font>{{ seeForm.dtuVersion }}</font>
        </p>
        <p>
          <font class="title">信号强度值：</font>
          <font>{{ seeForm.wifiRSSI }}</font>
        </p>
        <p>
          <font class="title">登记时间：</font>
          <font>{{ $filters.dateFilter(seeForm.createTime) }}</font>
        </p>
        <p>
          <font class="title">激活时间：</font>
          <font>{{ $filters.dateFilter(seeForm.activeTime) }}</font>
        </p>
        <p>
          <font class="title">最近在线时间：</font>
          <font>{{ $filters.dateFilter(seeForm.lastOnlineTime) }}</font>
        </p>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import tablePage from "@/components/standard/table.vue";
import search from "@/components/standard/searchList.vue";
import pagination from "@/components/standard/pagination.vue";
import { Message } from "element-ui";
export default {
  data() {
    return {
      seeBox: false,
      seeForm: {},
      selectArry: [],
      searchList: [
        {
          label: "MAC/SN",
          prop: "macSn",
          type: "input"
        },
        {
          label: "登记日期",
          prop: "activeTime",
          type: "datetimerange",
          startName: "登记开始日期",
          endName: "登记结束日期"
        }
      ],
      searchParams: {
        macSn: null,
        activeTime: null
      },
      columns: [
        {
          prop: "mac",
          label: "MAC地址",
          align: "left"
        },
        {
          prop: "sn",
          label: "SN序列号",
          align: "left",
          showOverflow: true
        },
        {
          prop: "deviceType",
          label: "产品类型",
          align: "left",
        },
        {
          prop: "deviceModel",
          label: "产品型号",
          align: "left",
        },
        // {
        //   prop: "init",
        //   label: "激活状态",
        //   align: "left",
        //   render: (h, params) => {
        //     return h("span", params.row.init ? "已激活" : "未激活");
        //   }
        // },
        {
          prop: "materialCode",
          label: "批次号",
          align: "left"
        },
        {
          prop: "insertTime",
          label: "登记日期",
          align: "left",
          width: 200,
          sortable: true,
          render: (h, params) => {
            return h("span", this.$utils.formatDate(params.row.insertTime));
          }
        },
        // {
        //   prop: "activeTime",
        //   label: "激活日期",
        //   align: "left",
        //   width: 200,
        //   sortable: true,
        //   render: (h, params) => {
        //     return h("span", this.$utils.formatDate(params.row.activeTime));
        //   }
        // },
        {
          label: "操作",
          width: 120,
          align: "left",
          fixed: "right",
          operates: [
            // {
            //   label: "查看",
            //   type: "primary",
            //   disabled: false,
            //   method: (index, row) => {
            //     this.handleDetail(row);
            //   }
            // },
            {
              label: "删除",
              type: "primary",
              disabled: false,
              method: (index, row) => {
                this.handleDelete(row);
              }
            }
          ]
        }
      ],
      tableData: [],
      tableFilter: {
        page: 1,
        pageSize: 10
      },
      total: 0
    };
  },
  mounted() {
    this.getRegisterList();
    this.getProductModel();
  },
  components: {
    tablePage,
    pagination,
    search
  },
  methods: {
    // 导入
    handleImportClick() {
      let file = this.$refs['uploadInput'].files[0]
      let formData = new FormData()
      if (file) {
        formData.append('file', file)
				this.$http.presetDeviceImport(formData).then((res) => {
          this.$message.success('导入成功')
					this.$refs['uploadInput'].value = null
				}).catch(() => {
					this.$refs['uploadInput'].value = null
				})
      }
    },
    //获取产品型号
    getProductModel(e) {
      this.$http
        .productModuleAll({
          productTypeId: e
        })
        .then(res => {
          if (res.data.success) {
            this.productModels = res.data.data;
            let list = [];
            for (let i in res.data.data) {
              list[i] = {
                label: res.data.data[i].productModel,
                value: res.data.data[i].id
              };
            }
            this.searchList[1].options = list;
          }
        });
    },
    // 获取列表
    getRegisterList() {
      let params = {
        ...this.tableFilter,
        ...this.searchParams,
        pageNumber: this.tableFilter.page
      };
      this.$http.devicePreSignList(params).then(res => {
        if (res.data.success) {
          this.$set(this, "tableData", res.data.rows);
          this.$set(this, "total", res.data.total);
        }
      });
    },
    // 查看
    handleDetail(raw) {
			this.seeForm = raw;
			this.$nextTick(() => {
				this.seeBox = true;
			});
      // this.$router.push("/standardDevice/deviceDetail?id=" + raw.id);
    },
    // 删除
    handleDelete(row) {
      this.$confirm(
        "<p style='margin-bottom:40px'>确认删除此设备吗？</p><p style='color:red;width:80%;position: absolute;top: 30px;'>删除此设备后，与此设备关联的用户都将失去该设备的控制权.</p>",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "warning"
        }
      )
        .then(() => {
          this.$http.devicePreSignDelete(row.id).then(res => {
            this.getRegisterList();
          });
        })
        .catch(() => {});
    },
    submitForm(formName) {
      if (formName == "searchParams") {
        if (this.searchParams.activeTime) {
					this.searchParams.activeStartTime = this.$utils.formatDate(
						this.searchParams.activeTime[0]
					);
					this.searchParams.activeEndTime = this.$utils.formatDate(
						this.searchParams.activeTime[1]
					);
          // 查询表单问题很大，注释下面这行应付
					// delete this.searchParams.activeTime;
				} else {
					this.searchParams.activeStartTime = null;
					this.searchParams.activeEndTime = null;
				}
        this.page = 1;
        this.limit = 10;
        this.getRegisterList();
      } else {
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (this.activeName == "创建版本类别") {
              this.$http.versionClassAdd(this.editForm).then(res => {
                if (res.data.success) {
                  this.$message({
                    message: "创建成功",
                    type: "success"
                  });
                  this.getRegisterList();
                }
              });
            } else {
              this.$http.versionClassEdit(this.editForm).then(res => {
                if (res.data.success) {
                  this.$message({
                    message: "编辑成功",
                    type: "success"
                  });
                  this.getRegisterList();
                }
              });
            }
            this.dialogVisible = false;
          }
        });
      }
    },
    resetForm(formName) {
      if (formName == "searchParams") {
        this.searchParams = {
					macSn: null,
					activeTime: null,
				};
        this.getRegisterList();
      } else {
        this.$refs[formName].resetFields();
        this.dialogVisible = false;
      }
    },
    // 导出
    handleExport() {
      if (this.selectArry.length > 0) {
        this.$http.deviceExport().then(res => {
          require.ensure([], () => {
            const {
              export_json_to_excel
            } = require("../../../assets/js/Export2Excel");
            var tHeader = [],
              filterVal = [];
            this.columns.forEach(i => {
              if (i.label != "操作") {
                tHeader.push(i.label);
                filterVal.push(i.prop);
              }
            });
            const list = Object.assign([], this.selectArry);
            list.forEach((item, index) => {
              item.productModel = item.product.productModel;
              for (var x in item) {
                if (x.indexOf("Time") != -1) {
                  item[x] = this.$filters.dateFilter(item[x], "");
                }
                if (x == "online") {
                  item[x] = item[x] ? "在线" : "离线";
                } else if (x == "init") {
                  item[x] = item[x] ? "已激活" : "未激活";
                } else if (x == "product") {
                  item[x] = item.productType.productType;
                }
              }
            });
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(
              tHeader,
              data,
              "设备登记列表" + this.$utils.formatDate(new Date())
            );
          });
        });
      } else {
        Message.error("请至少选择一项");
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    handleSelectionChange(rows) {
      this.selectArry = JSON.parse(JSON.stringify(rows));
    },
    // 判断按钮权限
    btnPer: function(name) {
      let list = this.$store.state.standard.menuNodeList,
        flag = false;
      for (let i in list) {
        if (list[i].href == name) {
          flag = true;
          break;
        }
      }
      return flag;
    }
  }
};
</script>

<style lang='less'>
.register {
  background: #ffffff;
}
.seeBox {
  .see-center {
    width: 100%;
    height: auto;
  }
  p {
    display: inline-block;
    margin: 10px 0;
    width: 100%;
    font {
      width: calc(100% - 150px);
      display: block;
      float: left;
      &.title {
        width: 150px;
        text-align: right;
      }
    }
  }
}
</style>
